var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    { staticClass: "form-fieldset grid grid__base", class: _vm.bemFacets },
    [
      _vm.name
        ? _c("legend", { staticClass: "form-fieldset--label" }, [
            _vm._v("\n        " + _vm._s(_vm.name) + "\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form--field-row" },
        [
          _vm.$slots.default
            ? _vm._t("default")
            : _vm._l(_vm.fields, function(field, fieldIdx) {
                return _c(
                  field.component,
                  _vm._b(
                    {
                      key: fieldIdx,
                      tag: "component",
                      staticClass: "form--field",
                      model: {
                        value: field.value,
                        callback: function($$v) {
                          _vm.$set(field, "value", $$v)
                        },
                        expression: "field.value"
                      }
                    },
                    "component",
                    _vm.bindFieldProps(field),
                    false
                  )
                )
              })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c3a690a2", { render: render, staticRenderFns: staticRenderFns })
  }
}